module.exports = __webpack_public_path__ + "img/intro_title_4.4bb682f8.png";